import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Badge,
  Box,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Typography
} from '@mui/material';
import { CloseOutlined, InfoRounded, NotificationImportantOutlined } from '@mui/icons-material';
import { getLatestNotifications, getOrderStatusCount } from 'services/notification-service';
import { connect } from 'react-redux';

const Notificationbar = (props) => {

  const [orderCounter, setOrderCounter] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  
  const [notifications, setNotifications] = useState([]);
  /* Notification Menu */
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOrderCounter([]);
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    if(anchorEl) {
      setIsProcessing(true);
      getOrderStatusCount('YARD').then(res => {
        setIsProcessing(false);
        if (res && res.data) {
          res.data.forEach(item => {
            orderCounter.push({ 'title': item.orderStatus, 'count': item.count });
          });
        }
      });
      getLatestNotifications().then(res => {
        setIsProcessing(false);
          if (res && res.data) {
            setNotifications(res.data);
          }
      });
    }
  }, [anchorEl]);

  const loggedUser = props.users && props.users.filter(u => u.email.toLowerCase() === localStorage.ACTIVE_USER_EMAIL.toLowerCase())[0];
  const initial = loggedUser && loggedUser.firstName[0] + loggedUser.lastName[0];
  return (
    <>
      <Box display='flex' justifyContent='space-between'>
        {/* ICONS */}
        <Tooltip title='Notifications' arrow>
          <IconButton onClick={handleClick} size="large">
            <Badge badgeContent={<InfoRounded color='secondary'/>} >
              <NotificationImportantOutlined />
            </Badge>
          </IconButton>
        </Tooltip>
        <Avatar style={{ width: 35, height: 35, marginLeft: 20, background: '#e33371' }}>
          <Typography>{initial}</Typography>
        </Avatar>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id='notifications'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        MenuListProps={{
          style: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant='h5'>{'Notifications'}</Typography>
          <IconButton aria-label="close" onClick={handleClose} size="large">
            <CloseOutlined />
          </IconButton>
        </MenuItem>
        <Divider />
        <Box style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          listStyle: 'none',
          padding: '5px',
          margin: '5px auto',
          width: '90%',
        }}>
          {isProcessing && <CircularProgress />}
          {orderCounter.map(item => {
            const label = item.title + ' ' + item.count;
            return (
              <Chip
                key={item.title}
                size='small'
                label={label}
                variant='outlined'
                color='secondary'
                style={{
                  marginLeft: '5px',
                  textAlign: 'center'
                }}
              />
            );
          })}
        </Box>
        <Divider/>
        {notifications.map(notify => {
          return <Box key={notify.timestamp}>
            <MenuItem onClick={handleClose} style={{ minHeight: '48px' }}>
              <Typography variant='subtitle2'>{notify.displayOrderId}</Typography>&nbsp;&nbsp;
              <Typography variant='body1'>{notify.message}</Typography>
            </MenuItem>
            <Divider />
          </Box>
          }
        )}
      </Menu>
    </>
  );
};

function mapStatesToProps(state) {
  // Whatevet is returned will show up as props
  const { users } = state.tenantReducer;
  return {users};
}

export default connect(mapStatesToProps)(Notificationbar);